import React, { type MutableRefObject } from 'react';
import { MoreOptionsVert } from '@elliemae/ds-icons';
import { DSMenuButton, MENU_ITEMS_TYPES } from '@elliemae/ds-menu-button';
import type { ScenarioRow } from '.';

type RowActions = {
  onDuplicate: (row: ScenarioRow) => void;
  onDelete: (row: ScenarioRow) => void;
  boundaryRef: MutableRefObject<HTMLDivElement | null>;
};

const ACTION_DUPLICATE = 'duplicate';
const ACTION_DELETE = 'delete';

// Edit and Qualify ship with the Create/Edit and Quick Qualify stories.
const ROW_ACTION_OPTIONS = [
  { dsId: 'edit', label: 'Edit', disabled: true },
  { dsId: ACTION_DUPLICATE, label: 'Duplicate' },
  { dsId: ACTION_DELETE, label: 'Delete' },
  { dsId: 'qualify', label: 'Qualify', disabled: true },
].map((option) => ({ ...option, type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM }));

// Data columns plus a trailing kebab menu of row actions.
export const getColumns = ({
  onDuplicate,
  onDelete,
  boundaryRef,
}: RowActions) => [
  { Header: 'LOAN ID', accessor: 'loanId' },
  { Header: 'NAME', accessor: 'name' },
  { Header: 'CHANNEL TYPE', accessor: 'channelType' },
  { Header: 'LTV', accessor: 'ltv' },
  { Header: 'FICO', accessor: 'fico' },
  { Header: 'OCCUPANCY', accessor: 'occupancy' },
  { Header: 'CREATED DATE', accessor: 'createdDate' },
  { Header: 'MODIFIED DATE', accessor: 'modifiedDate' },
  {
    Header: '',
    accessor: 'actions',
    width: 48,
    Cell: ({ row }) => {
      const scenario = row.original as ScenarioRow;
      return (
        <DSMenuButton
          buttonType="icon"
          aria-label={`Actions for ${scenario.name}`}
          options={ROW_ACTION_OPTIONS}
          floatingConfig={{ boundaryElement: boundaryRef.current }}
          onActivateItem={({ plainItem: { dsId } }: any) => {
            if (dsId === ACTION_DUPLICATE) onDuplicate(scenario);
            if (dsId === ACTION_DELETE) onDelete(scenario);
          }}
        >
          <MoreOptionsVert />
        </DSMenuButton>
      );
    },
  },
];
